import { createReducer } from '@topconagriculture/frontend-utils';

import { Company } from './company.types';
import { getCompaniesList } from './company.actions';

export type CompanyState = Company[];

const initialState: Company[] = [];

const companyReducer = createReducer(initialState, {
  [getCompaniesList.done.type]: (state, action: ReturnType<typeof getCompaniesList.done>) => action.payload.result,
});

export default companyReducer;
